import React, { useState, useEffect } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Course2Header from "./Course2Header";
import CourseCreate from "./CourseCreate";

const EditCourse = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Course2Header  />
          </PageHeader>

          <div className="main-content">
            <div className="row">
              <CourseCreate  />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default EditCourse;
